import RichText from "../rich-text/renderer"
import styled, { css } from "styled-components"
import { MikanSpan } from "@components/Mikan"

export const StyledSuggestContent = styled.div`
  width: 100%;
  padding: ${(props) => (props.spacing ? props.spacing : `128px 0`)};
  max-width: 1140px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const StyledSuggestContentIntro = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  max-width: 1140px;
  margin-bottom: 53px;
  h2 {
    color: var(--black);
  }
  @media (min-width: 768px) {
    margin-bottom: 48px;
  }
  @media (min-width: 1200px) {
    align-items: flex-start;
  }
`

export const StyledSuggestContentList = styled.div`
  width: 100%;
  display: grid;
  gap: 32px;
  max-width: 1140px;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  ${(props) =>
    props.classNames === "cloud-security" &&
    css`
      & > div:last-of-type a {
        padding-right: 0;
        &:before {
          transform: translate(1.5rem, 30%);
        }
      }
    `}
`

export const StyledSuggestContentItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 230px;
  border-radius: 16px;
  background-color: var(--white);
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.06);
  // sometimes there are additional empty paragraphs from contentful
  p:empty {
    display: none;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 1rem;
  border-bottom: solid 1px var(--grey-30);

  p,
  > div {
    font-size: 12px;
    padding: 2px 5px 0 5px;
    padding: ${({ theme }) => theme.space["2xs"]};
    color: var(--grey-70);
    background-color: var(--grey-30);
    border-radius: 2px;
    margin-bottom: 0;
  }
`

export const Body = styled.div`
  // h6 should not be smaller than paragraph text on mobile devices
  --h6: 700 1rem/125% var(--font);
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.125rem 1rem 0;

  /* Temporary ajustment cta */
  a {
    text-decoration: none;

    &:before {
      right: 5px;
      top: 0px;
    }
  }

  h6 > a {
    color: var(--grey-90);

    &:hover {
      text-decoration: underline;
    }
  }
`

export const Footer = styled.div`
  padding: 1.125rem 1rem;
  align-self: end;
  width: 100%; // for Firefox
`

export const StyledIcon = styled.span`
  width: ${(props) => (props.iconsProps.width ? props.iconsProps.width : "52px")};
  height: ${(props) => (props.iconsProps.height ? props.iconsProps.height : "52px")};
  margin: 0 0.8rem 0 0;
  mask: url("${(props) => props.src && props.src}");
  mask-size: contain;
  -webkit-mask: url("${(props) => props.src && props.src}");
  -webkit-mask-size: contain;
  background: ${(props) => (props.iconsProps.color ? `var(--${props.iconsProps.color})` : "var(grey--90)")};
  -webkit-mask-repeat: no-repeat;
`

const SuggestContent = ({ classNames, label, content, iconsProps, spacing }) => {
  return (
    <StyledSuggestContent spacing={spacing}>
      <StyledSuggestContentIntro>
        <h2>
          <MikanSpan text={label} />
        </h2>
      </StyledSuggestContentIntro>
      <StyledSuggestContentList classNames={classNames}>
        {content.map((item) =>
          item.excludeFromLocale ? null : (
            <StyledSuggestContentItem key={item.contentful_id}>
              <Header>
                <StyledIcon src={item.media.content.file.url} iconsProps={iconsProps}></StyledIcon>
                <p>{item.header}</p>
              </Header>
              <Body>
                <RichText body={item.content} mikan={item.mikan} />
              </Body>
              <Footer>
                <RichText body={item.footer} mikan={item.mikan} />
              </Footer>
            </StyledSuggestContentItem>
          )
        )}
      </StyledSuggestContentList>
    </StyledSuggestContent>
  )
}

export default SuggestContent
